import { getCommonStyle } from '../styleCommon';

export function getHAStyles() {

	const commonFontFamily = getCommonStyle('font.family');

	return {
		color: '#aaa',
		height: 15,
		margin: 5,
		text: {
			background: {
				color: '#ccc'
			},
			color: '#000',
			font: {
				family: commonFontFamily,
				size: 12,
				weight: 'normal'
			},
			hover: {
				background: {
					color: '#333'
				},
				color: '#aaa',
				font: {
					family: commonFontFamily,
					size: 11,
					weight: 'normal'
				}
			}
		},
		width: 1
	};
}
